import { useTranslation } from 'react-i18next';
import { UsersPage } from 'shared/users';
import useUsersHostProps from './useUsersHostProps';

// The main User Management page: the shared Users feature scoped to the logged-in account. The
// sub-account User Management drawer mounts the same feature scoped to a sub-account via its bearer.
export default function UserManagementPage() {
  const { t } = useTranslation('translations', { keyPrefix: 'Users.UsersList' });
  const usersHostProps = useUsersHostProps({ title: t('title', { defaultValue: 'User Management' }) });

  return <UsersPage {...usersHostProps} />;
}
